// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { castToString } from 'helpers/reduxFormFunctions'
import createModConfigs from './createModConfigs'
import parseModConfig from './parseModConfig'
import { initialRadioValues } from 'redux/modules/pathDetails'

// NOTE - if a radio is null, then there can be no radioModulationConfigurations

const radioDataForForm = segmentEnd => {
  const {
    acmCoordinationAdvantageFlag,
    radio,
    radioModulationConfigurations,
  } = segmentEnd

  if (radio === null) {
    return initialRadioValues
  }

  const {
    architecture,
    atpcAlarmFlag,
    atpcType,
    companyName,
    dynamicPowerFlag,
    radioFavorite,
    radioId,
  } = radio

  const radioCode = (
    radioFavorite
      ? radioFavorite.favoriteRadioCode
      : radio.radioCode
  )

  const legacyRadioCode = radioFavorite?.legacyRadioCode || null
  const modConfigs = createModConfigs({ radio, radioModulationConfigurations })
  const modulationType = radio.modulationType.modulationType[0].toLowerCase()
  const powerType = castToString(radio.powerType)
  const radioFamilyName = radio.radioFamilyName || 'N/A'
  const radioFavoriteId = radioFavorite?.radioFavoriteId || null

  // if ATPC is disabled, powerIncrease value will come from radio.
  const {
    bandwidth,
    engineeringReference,
    maxPower,
    modelNumber,
    modulations,
  } = parseModConfig(modConfigs)

  // coordinated power comes from the segment end level
  const coordinatedPower = castToString(segmentEnd.coordinatedPower)

  // if atpc isn't enabled, the API will give it as null.
  // in that case, give a set of initial ATPC values
  const atpc = segmentEnd.atpc

  const atpcEnabled = atpc ? atpc.atpcEnabled : false

  return {
    acmCoordinationAdvantageFlag,
    atpc,
    atpcEnabled,
    atpcAlarmFlag, // used as an initial value for 5 min increase in ATPC - can be null!
    atpcType, // used as initial value for Power Increase in ATPC - can be null!
    architecture,
    bandwidth,
    companyName,
    coordinatedPower,
    dynamicPowerFlag,
    engineeringReference,
    legacyRadioCode,
    maxPower,
    modelNumber,
    modulations,
    modulationType,
    powerType,
    radioCode,
    radioFamilyName,
    radioFavoriteId,
    radioId,
  }
}

export default radioDataForForm
